// extracted by mini-css-extract-plugin
module.exports = {"courses":"turnkey_courses__2hbuX","img1":"turnkey_img1__2bCaH","img2":"turnkey_img2__3zuKc","img3":"turnkey_img3__1L-L8"};